import { render } from "./FooterMap.vue?vue&type=template&id=561ac09c&scoped=true"
import script from "./FooterMap.vue?vue&type=script&lang=js"
export * from "./FooterMap.vue?vue&type=script&lang=js"

import "./FooterMap.vue?vue&type=style&index=0&id=561ac09c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-561ac09c"

export default script